import LayerKeys from '~/config/layerKeys'
import { Door } from '~/store/objects/types'

export type Orientation = NonNullable<Door['product']>['orientation']

export type DoorProduct = {
  name: string
  sizes: { label: string; voltages: string[] }[]
  category: 'PRODUCTS_DIRECTIONAL' | 'PRODUCTS_HEATERS'
  orientations: Orientation[]
}

export const doorProducts: DoorProduct[] = [
  {
    name: 'Velocity',
    sizes: [{ label: 'Standard', voltages: ['110-120V/1', '208-240V/1'] }],
    category: LayerKeys.PRODUCTS_DIRECTIONAL,
    orientations: ['left', 'right'],
  },
  {
    name: 'DTH',
    sizes: [
      { label: '18', voltages: ['208-240V/3', '480V/3', '600V/3'] },
      { label: '30', voltages: ['480V/3', '600V/3'] },
    ],
    category: LayerKeys.PRODUCTS_HEATERS,
    orientations: ['center'],
  },
]
